// extracted by mini-css-extract-plugin
module.exports = {"container":"PreviewSwiperPagination_container__qBMo6"};